import { IErknmAgreementChange } from 'APIPackage/KnmModule/interfaces/IErknmAgreementChange';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { IAgreementChangeReasonSelectOption } from 'CorePackage/CatalogsModule/interfaces/IAgreementChangeReasonSelectOption';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';

import { IErknmFormAgreementChange } from '../interfaces/IErknmFormAgreementChange';

export const convertAgreementsChangesFormValuesToData = (
  changes: IErknmFormAgreementChange[] | undefined,
): IErknmAgreementChange[] | null => {
  if (!changes) return null;

  return changes.map(item => {
    return {
      guid: item.guid || null,
      signed: typeof item.signed === 'boolean' ? item.signed : null,
      types: !item.types
        ? null
        : item.types.map(typeItem => {
            return {
              guid: typeItem.guid,
              type: typeItem.type?.value || '',
            };
          }),
      reasons: (item.reasons?.map(reason => reason).filter(i => !!i) as IAgreementChangeReasonSelectOption[]) || null,
      attachment: convertKnmDocumentAttachmentsFormValuesToKnmData(item.attachment)?.pop() || null,
      termOfExecutionAgreement: convertFormDateValueToKnmDataDate(item.termOfExecutionAgreement),
      updatedAgreementAttachment:
        convertKnmDocumentAttachmentsFormValuesToKnmData(item.updatedAgreementAttachment)?.pop() || null,
      petitionAttachment: convertKnmDocumentAttachmentsFormValuesToKnmData(item.petitionAttachment)?.pop() || null,
      fioSigner: item.fioSigner?.trim() || null,
      titleSigner: item.titleSigner?.value || null,
    };
  });
};
